import type {
  ResourceListResult,
  ResourcePagination,
  ResourceRecordResult,
} from 'core/resources'
import { JsonRecord } from 'core/resources/deriveColumns'

/**
 * The generated hooks name a row type per resource, while the views render
 * whatever the schema describes. Narrowing here keeps one cast per shape
 * rather than one at every mount.
 */
export const record = (result: {
  data?: unknown
  isLoading: boolean
  error: unknown
}): ResourceRecordResult => ({
  data: result.data as JsonRecord | undefined,
  error: result.error,
  isLoading: result.isLoading,
})

export const listRows = (result: {
  data?: unknown
  pagination?: ResourcePagination
  isLoading: boolean
  error: unknown
}): ResourceListResult => ({
  data: result.data as Array<JsonRecord> | undefined,
  error: result.error,
  isLoading: result.isLoading,
  pagination: result.pagination,
})

/**
 * DynamicForm builds its payload from a runtime schema, so what arrives is a
 * loose record while each generated hook names an exact body.
 */
export const asRequestBody = <Body>(body: JsonRecord): Body =>
  body as unknown as Body

/** The generated create hooks resolve to the API envelope; the id is inside. */
export const createdId = (result: unknown): string | undefined => {
  const id = (result as { data?: { id?: unknown } } | null)?.data?.id
  return typeof id === 'string' ? id : undefined
}
